import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import ImageSlot from '../components/ImageSlot';

const NotFound = () => (
  <div className="page">
    <SEO title="Not Found" description="That page doesn't exist on aurablox.com." path="/404" noindex />
    <header className="page-head page-head--media" id="top">
      <div className="page-head__text">
        <h1>This page slipped the grid.</h1>
        <p className="page-head__lede">
          The link you followed doesn't lead anywhere on this site. Try the home page, or pick
          a section below.
        </p>
      </div>
      <ImageSlot
        src="/images/aurablox-audit.jpg"
        alt="Constructivist grid"
        ratio="4/3"
        label="Constructivist grid"
      />
    </header>

    <main>
      <section className="section" aria-labelledby="nav">
        <div className="section__header">
          <h2 id="nav">Where to next</h2>
          <p>The main entry points on the AURABLOX site.</p>
        </div>
        <div className="grid grid--cards">
          <article className="card"><h3>Home</h3><p>AURABLOX overview, capabilities, and sector experience.</p><Link className="card__link" to="/">Go home</Link></article>
          <article className="card"><h3>Our work</h3><p>Live products, prototypes, and technical architecture.</p><Link className="card__link" to="/technology">See working examples</Link></article>
          <article className="card"><h3>Capabilities</h3><p>Software engineering, data systems, and applied AI.</p><Link className="card__link" to="/solutions">View capabilities</Link></article>
          <article className="card"><h3>Contact</h3><p>Talk directly with the team about your project.</p><Link className="card__link" to="/contact#inquiry">Get in touch</Link></article>
        </div>
      </section>
    </main>
  </div>
);

export default NotFound;
